import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

import PageTitle from "../../../../layouts/PageTitle";
import { appApi, useGetSuppliersQuery } from "../../../../../store/appApi";
import { selectHasModuleAccess } from "../../../../../store/authSlice";

const theadData = [
  // { heading: "S.No.", sortingVale: "" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Address", sortingVale: "address" },
  { heading: "GST Number", sortingVale: "gstNumber" },
  { heading: "Added On", sortingVale: "created" },
  { heading: "Action", sortingVale: "" },
];

const SupplierList = () => {
  const dispatch = useDispatch();
  const hasSuppliersWrite = useSelector(selectHasModuleAccess("suppliers", "read-write"));

  const [sort, setSortata] = useState(10);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // ── Debounce search ──────────────────────────────────────────────────────
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(t);
  }, [searchTerm]);

  // ── GET via Redux ────────────────────────────────────────────────────────
  const {
    data: suppliersResponse,
    isLoading,
    isFetching,
  } = useGetSuppliersQuery();

  const rawList = Array.isArray(suppliersResponse?.suppliers)
    ? suppliersResponse.suppliers
    : [];

  // Client-side search filter
  const filtered = debouncedSearch
    ? rawList.filter((s) =>
        `${s.name} ${s.address} ${s.gstNumber}`
          .toLowerCase()
          .includes(debouncedSearch.toLowerCase()),
      )
    : rawList;

  const total = filtered.length;
  const totalPages = Math.ceil(total / Number(sort)) || 1;
  const pageData = filtered.slice(
    (page - 1) * Number(sort),
    page * Number(sort),
  );
  const paggination = Array(totalPages)
    .fill()
    .map((_, i) => i + 1);
  const showingFrom = total > 0 ? (page - 1) * Number(sort) + 1 : 0;
  const showingTo = total > 0 ? Math.min(page * Number(sort), total) : 0;
  const showLoading = isLoading || isFetching;

  return (
    <>
      <PageTitle activeMenu={"All Suppliers"} motherMenu={"Inventory"} />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Supplier List</h4>
              {hasSuppliersWrite && (
                <Link to={"/add-supplier"} className="btn btn-primary">
                  + Add New
                </Link>
              )}
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="supplierList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(10);
                                setPage(1);
                              }}
                            >
                              10
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(20);
                                setPage(1);
                              }}
                            >
                              20
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(30);
                                setPage(1);
                              }}
                            >
                              30
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search:{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {theadData.map((item, ind) => (
                          <th key={ind}>{item.heading}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {showLoading && (
                        <tr>
                          <td colSpan={6}>Loading suppliers...</td>
                        </tr>
                      )}
                      {!showLoading && pageData.length === 0 && (
                        <tr>
                          <td colSpan={6}>No suppliers found.</td>
                        </tr>
                      )}
                      {!showLoading &&
                        pageData.map((item, ind) => (
                          <tr key={item._id || ind}>
                            {/* <td>{(page - 1) * Number(sort) + ind + 1}</td> */}
                            <td style={{ textTransform: "capitalize" }}>
                              {item.name || "—"}
                            </td>
                            <td>{item.address || "—"}</td>
                            <td>{item.gstNumber || "—"}</td>
                            <td>
                              {item.created
                                ? new Date(item.created).toLocaleDateString(
                                    "en-IN",
                                  )
                                : "—"}
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <Link
                                  to={`/supplier-profile/${item._id}`}
                                  className="btn btn-xs btn-outline-info"
                                >
                                  View
                                </Link>
                                {hasSuppliersWrite && (
                                  <Link
                                    to={`/edit-supplier/${item._id}`}
                                    className="btn btn-xs sharp btn-primary"
                                  >
                                    <i className="fa fa-pencil" />
                                  </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                    <div className="dataTables_info">
                      Showing {showingFrom} to {showingTo} of {total} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    >
                      <Link
                        className={`paginate_button previous ${page <= 1 ? "disabled" : ""}`}
                        to="#"
                        onClick={() => page > 1 && setPage(page - 1)}
                      >
                        Previous
                      </Link>
                      <span>
                        {paggination.map((number, i) => (
                          <Link
                            key={i}
                            to="#"
                            className={`paginate_button ${page === number ? "current" : ""}`}
                            onClick={() => setPage(number)}
                          >
                            {number}
                          </Link>
                        ))}
                      </span>
                      <Link
                        className={`paginate_button next ${page >= totalPages ? "disabled" : ""}`}
                        to="#"
                        onClick={() => page < totalPages && setPage(page + 1)}
                      >
                        Next
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SupplierList;
